export default __webpack_public_path__ + "download-btn-plp-x9D.svg";